import React from 'react';
import { Table, Card, Row, Col, Statistic } from 'antd';
import _ from 'lodash';

const CamposGrid = ({ jogos }) => {
  const columns = [
    {
      title: 'Dia',
      dataIndex: 'dia',
      key: 'dia',
      // no ellipsis, so text won't shrink
    },
    {
      title: 'Hora',
      dataIndex: 'hora',
      key: 'hora',
    },
    {
      title: 'Jogo',
      dataIndex: 'JOGO',
      key: 'JOGO',
      fixed: 'left',
    },
    {
      title: 'Campo',
      dataIndex: 'campo',
      key: 'campo',
    },
    {
      title: 'Referência',
      dataIndex: 'referencia',
      key: 'referencia',
    },
    {
      title: 'Escalão',
      dataIndex: 'escalao',
      key: 'escalao',
    },
    {
      title: 'Grupo',
      dataIndex: 'grupo',
      key: 'grupo',
    },
    {
      title: 'Equipa Casa',
      dataIndex: 'nomecasa',
      key: 'nomecasa',
    },
    {
      title: 'Balneário Casa',
      dataIndex: 'balneariocasa',
      key: 'balneariocasa',
    },
    {
      title: 'N_Casa',
      dataIndex: 'njogadorescasa',
      key: 'njogadorescasa',
    },
    {
      title: 'Equipa Fora',
      dataIndex: 'nomefora',
      key: 'nomefora',
    },
    {
      title: 'Balneário Fora',
      dataIndex: 'balneariofora',
      key: 'balneariofora',
    },
    {
      title: 'N_Fora',
      dataIndex: 'njogadoresfora',
      key: 'njogadoresfora',
    },
    {
      title: 'Num Campo',
      dataIndex: 'numcampo',
      key: 'numcampo',
    },
    {
      title: 'Total',
      dataIndex: 'totaljogadores',
      key: 'totaljogadores',
    },
    {
      title: 'Id Jogo',
      dataIndex: 'id',
      key: 'id',
    },
  ];

  const totalCasa = _.sumBy(jogos, 'njogadorescasa');
  const totalFora = _.sumBy(jogos, 'njogadoresfora');
  const totalGeral = totalCasa + totalFora;

  return (
    <div style={{ fontSize: '12px' }}>
      <Card style={{ marginBottom: 16 }} size="small">
        <Row gutter={8}>
          <Col span={6}>
            <Statistic
              title="Jogadores Casa"
              value={totalCasa}
              valueStyle={{ fontSize: '16px' }}
              style={{ fontSize: '11px' }}
            />
          </Col>
          <Col span={6}>
            <Statistic
              title="Jogadores Fora"
              value={totalFora}
              valueStyle={{ fontSize: '16px' }}
              style={{ fontSize: '11px' }}
            />
          </Col>
          <Col span={6}>
            <Statistic
              title="Total Jogadores"
              value={totalGeral}
              valueStyle={{ fontSize: '16px' }}
              style={{ fontSize: '11px' }}
            />
          </Col>
          <Col span={6}>
            <Statistic
              title="Total Jogos"
              value={jogos.length}
              valueStyle={{ fontSize: '16px' }}
              style={{ fontSize: '11px' }}
            />
          </Col>
        </Row>
      </Card>

      <Table
        columns={columns}
        dataSource={jogos}
        pagination={false}
        size="small"
        bordered
        // Set a large 'x' value to ensure horizontal overflow.
        // 'y' fixes the table header and makes the body scrollable up to 500px tall.
        scroll={{ x: 1500, y: 500 }}
      />
    </div>
  );
};

export default CamposGrid;
